import { useCallback, useEffect, useMemo } from 'react';
import { useToggleable } from '../hooks';

import { WEBSKY_BAGGAGE_SERVICE_OPEN_EVENT } from '../Checkout/constants';
import { BaggageServiceOpenEvent } from '../Checkout/types';
import { Baggage } from '../BaggageService/types';

export const useBaggageToggleable = (baggage: Baggage[]) => {
	const { open, ...toggleableProps } = useToggleable(false);

	const availableBaggageTypes = useMemo(() => {
		return [...new Set(baggage.map(baggage => baggage.type))];
	}, [baggage]);

	const onEventHandler = useCallback(
		(event: CustomEvent<BaggageServiceOpenEvent>) => {
			const { type } = event.detail;

			if (availableBaggageTypes.includes(type)) {
				open();
			}
		},
		[availableBaggageTypes, open]
	);

	useEffect(() => {
		document.addEventListener(WEBSKY_BAGGAGE_SERVICE_OPEN_EVENT, onEventHandler as EventListener);

		return () => document.removeEventListener(WEBSKY_BAGGAGE_SERVICE_OPEN_EVENT, onEventHandler as EventListener);
	}, []);

	return { ...toggleableProps, open };
};
